function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Stack, IconButton, Icon } from '@tapresearch/ui/components';
export var GraphToggleSwitch = function(param) {
    var leftItem = param.leftItem, rightItem = param.rightItem, _param_selectedItem = param.selectedItem, selectedItem = _param_selectedItem === void 0 ? 'left' : _param_selectedItem;
    return /*#__PURE__*/ React.createElement(Stack, {
        "data-testid": "graph-toggle-switch",
        direction: "row",
        spacing: "0"
    }, /*#__PURE__*/ React.createElement(IconButton, _object_spread(_object_spread_props(_object_spread({}, commonProps), {
        'aria-label': leftItem.label,
        'data-testid': selectedItem === 'left' ? 'left-toggle-item-selected' : 'left-toggle-item',
        rounded: '4px 0 0 4px',
        icon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 6,
            icon: leftItem.icon
        }),
        onClick: leftItem.callback
    }), selectedItem === 'left' && selectedProps)), /*#__PURE__*/ React.createElement(IconButton, _object_spread(_object_spread_props(_object_spread({}, commonProps), {
        'aria-label': rightItem.label,
        'data-testid': selectedItem === 'right' ? 'right-toggle-item-selected' : 'right-toggle-item',
        rounded: '0 4px 4px 0',
        icon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 6,
            icon: rightItem.icon
        }),
        onClick: rightItem.callback
    }), selectedItem === 'right' && selectedProps)));
};
var commonProps = {
    m: 0,
    px: 5,
    variant: 'outline',
    outline: 0,
    borderColor: 'gray.200',
    color: 'gray.600',
    height: 9,
    minW: 12,
    _focus: {
        boxShadow: 'none'
    }
};
var selectedProps = {
    bg: 'blue.100',
    color: 'blue.500',
    borderColor: 'blue.300'
};
